import { cardsData } from "@/mocks/homeData";

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-50 text-center mb-2">精彩内容推荐</h2>
        <p className="text-foreground-500 text-sm text-center mb-8 md:mb-10">每日精选优质影视内容，总有一部适合你</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cardsData.map((card) => (
            <article
              key={card.title}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = "none";
                  }}
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-950 text-xs font-medium rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-foreground-100 text-sm md:text-base font-medium mb-1.5 line-clamp-1">{card.title}</h3>
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2 mb-2">{card.desc}</p>
                <time className="text-foreground-700 text-xs" dateTime={card.date}>
                  <span className="w-3.5 h-3.5 flex items-center justify-center inline-block mr-1 align-text-bottom">
                    <i className="ri-time-line text-[10px]"></i>
                  </span>
                  {card.date}
                </time>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}